import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-5" }
const _hoisted_2 = { class: "text-center text-xs font-medium text-gray-500" }
const _hoisted_3 = { class: "mt-1 text-center text-2xl font-semibold text-gray-800" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SummaryMetricsPanel',
  props: {
    metrics: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metrics, ({ title, metric }) => {
      return (_openBlock(), _createBlock(_component_UiPanel, { key: title }, {
        default: _withCtx(() => [
          _createElementVNode("dt", _hoisted_2, _toDisplayString(title), 1),
          _createElementVNode("dd", _hoisted_3, _toDisplayString(metric), 1)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})